<template>
  <div class="HeaderWrap">
    <div class="Header mobile">
      <div class="mobile-bar">
        <BarStream :time-visible="false"></BarStream>
        <button :class="{
          'icon-mobile-menu': !mobileOpen,
          'icon-mobile-menu-close': mobileOpen,
        }" @click="mobileOpen = !mobileOpen">
          <span></span>
        </button>
      </div>
      <div class="mobile-nav" :style="{ display: mobileOpen ? 'flex' : 'none' }">
        <vue-link to="/" :class="{
          active: $route.path === '/',
        }"><span>Home</span></vue-link>
        <vue-link :to="link.url" v-for="link in links" :key="link.url" :class="{
          active: $route.meta.active === link.url,
        }"><span>{{ link.title }}</span></vue-link>
        <div class="search-link">
          <router-link to="/search" class="icon-search-sprite"></router-link>
          <router-link to="/search">Search</router-link>
        </div>
      </div>
    </div>
    <div class="Header desktop a-hover">
      <div class="header-holder">
        <div class="header-logo">
          <div class="spacer"></div>
          <router-link class="dublab-link" to="/">dublab</router-link>
          <div class="spacer"></div>
        </div>
        <div class="header-stack">
          <div class="Navigation">
            <router-link to="/search" class="icon-search-sprite"></router-link>
            <vue-link :to="link.url" v-for="link in links" :key="link.url" :class="{
              active: $route.meta.active === link.url,
            }">
              <span>{{ link.title }}</span>
            </vue-link>
            <h1></h1>
            <div v-if="timeVisible" class="time">
              {{ date.time }} {{ date.timezone }}
            </div>
          </div>
          <BarStream></BarStream>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueLink from "./VueLink.js";
import BarStream from "./BarStream";

export default {
  name: "Header",
  components: { VueLink, BarStream },
  props: {
    timeVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      mobileOpen: false,
    };
  },
  watch: {
    $route() {
      this.mobileOpen = false;
    },
  },
  computed: {
    site() {
      return this.$store.state.content["star"];
    },
    links() {
      if (!this.site) return [];
      return this.site.navigation;
    },
    takeoverTitleReversed() {
      let title = this.site.takeover.title;
      let reversed = title.split(" ").reverse();
      return reversed;
    },
    date() {
      return this.$store.state.date.local;
    },
  },
};
</script>

<style scoped>
.Header {
  background: #fff;
  display: flex;
  flex-wrap: wrap;
  z-index: 9;
}

.header-holder {
  display: flex;
  flex-direction: row;
  border: 1px solid black;
}

.header-logo {
  display: flex;
  height: 70px;
  width: fit-content;
  border-right: 1px solid black;
  padding: 0.4em 0;
  font-size: 1.6em;
  text-align: center;
}

.spacer {
  width: 50px;
}

.header-stack {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header-space {
  height: 8rem;
}

[class*="icon"] {
  margin-right: 2rem;
  flex-shrink: 0;
}

.icon-search {
  font-size: 0.75em;
}

.Header>div {
  width: 100%;
}

.Header>div:last-child {
  border-top: var(--b1);
}

.search-link {
  display: flex;
  margin-top: 2rem;
}

.search-link .icon-search-sprite {
  margin-right: 1rem;
}

@media (max-width: 1200px) {
  .time {
    display: none;
  }
}

@media (max-width: 920px) {
  .mobile {
    display: block;
  }

  .desktop {
    display: none;
  }

  .header-space {
    height: 7.25rem;
  }

  .header-space.mobile-open {
    height: 28.25rem;
  }
}

@media (min-width: 920px) {
  .mobile {
    display: none;
  }

  .desktop {
    display: block;
  }
}
</style>

<style scoped>
.Header.mobile {
  border-bottom: var(--b1);
  padding: 0;
}

.Header.mobile>div {
  padding: 1.3rem 2rem 1.4rem 2rem;
}

.mobile-bar {
  display: flex;
  padding: 2rem 0;
}

.mobile-bar .BarStream {
  flex: 1;
  margin-right: 2rem;
  max-width: calc(100% - 4rem);
}

.mobile-bar button {
  margin-right: 0;
  width: 1.2em;
}

.mobile-nav {
  flex-wrap: wrap;
  border-top-style: dashed !important;
}

.mobile-nav>a {
  display: block;
  width: 50%;
  font: var(--large);
  /*line-height: var(--lh3);*/
}

.mobile-nav .search-link {
  margin-top: 3rem;
  margin-bottom: 0.5rem;
}
</style>

<style scoped>
.Navigation {
  display: flex;
  font-weight: 300;
  /*white-space: nowrap;*/
  width: 100%;
  height: 35px;
  border-bottom: 1px solid black;
  align-items: baseline;
}

/* fix font sizes here
.Navigation span {
  font: var(--mediumsmall);
}
*/

.Navigation>h1 {
  display: block;
  margin-left: auto;
  overflow: hidden;
  height: 1.2em;
  text-align: right;
}

.drive-title {
  display: inline-block;
}

.drive-title span {
  float: right;
}

.drive-title span::before {
  content: "\00a0";
}

.Navigation [class*="icon-search"] {
  font-size: 0.75em;
  margin-right: 2rem;
  margin-left: 2rem;
}

.Navigation a {
  margin-right: 1.4rem;
}

.Navigation h1 a {
  margin-right: 0;
}

.time {
  margin-left: auto;
  margin-right: 2rem;
  white-space: nowrap;
}

a.router-link-active:not([href="/"]),
a.active span {
  color: var(--accent);
}
</style>
